export default __webpack_public_path__ + "static/media/card-radio-button-active.bd78c2df.svg";